/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Ev_StuckInputs */

const en_fw_notify_ev_stuck = /** @type {(inputs: Fw_Notify_Ev_StuckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent stuck`)
};

const id_fw_notify_ev_stuck = /** @type {(inputs: Fw_Notify_Ev_StuckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen tersangkut`)
};

/**
* | output |
* | --- |
* | "Agent stuck" |
*
* @param {Fw_Notify_Ev_StuckInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_ev_stuck = /** @type {((inputs?: Fw_Notify_Ev_StuckInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Ev_StuckInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_ev_stuck(inputs)
	return en_fw_notify_ev_stuck(inputs)
});